import React, { useEffect, useState } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import axios from 'axios';
import SvgLocation from "../components/svg/SvgLocation";
import Navbar from "react-bootstrap/Navbar";
import Logo from "../assets/images/logo.png";
import {IconMenuDeep} from "@tabler/icons-react";
import bakimlogo from "../assets/images/22890737_6658659.svg";

function Contact() {
    const [contactData, setContactData] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        async function getItem() {
            try {
                const response = await axios.get("https://admin.maviada.co/api/iletisim");
                if (response?.data?.data?.length > 0) {
                    setContactData(response.data.data[0]);
                } else {
                    setError("İletişim verisi bulunamadı.");
                }
            } catch (err) {
                console.error("API Hatası:", err);
                setError("Veri alınırken bir hata oluştu.");
            }
        }

        getItem();
    }, []);

    if (error) {
        return <div className="text-center mt-5 text-danger">{error}</div>;
    }

    if (!contactData) {
        return <div className="text-center mt-5">Yükleniyor...</div>;
    }

    return (
        <div className='hero page-wrapper'>
            <section className='hero'>
                <Container>
                    <Row className="justify-content-center">
                        <Navbar.Brand href="/">
                            <img src={Logo} alt="logo" className={'header-logo'}/>
                        </Navbar.Brand>
                        <Navbar.Toggle >
                            <h1 style={{marginBottom:"100px"}}>Yakında Sizlerle</h1>
                        </Navbar.Toggle>

                        <Col md={7} lg={6}>
                            <h5 className='mb-2'>{contactData.title}</h5>
                            <Row>
                                <Col md={8} className='mb-3'>
                                    <h3 className='mb-0'>ADRES</h3>
                                    <p>{contactData.address}</p>
                                </Col>
                                {/*<Col md={4} className='mb-3'>
                                    <h3 className='mb-0'>TELEFON</h3>
                                    <a href={`tel:${contactData.phone_number}`} className="text-default">
                                        {contactData.phone_number}
                                    </a>
                                </Col>*/}
                                <Col sm={12}>
                                    <h3 className='mb-0'>E-POSTA</h3>
                                    <a href={`mailto:${contactData.mail}`} className="text-default">
                                        {contactData.mail}
                                    </a>
                                </Col>
                            </Row>
                        </Col>
                        <Col md={5} lg={4}>
                            <div className='contact-icon'>
                                <img src={bakimlogo} alt=""/>
                            </div>
                        </Col>
                        <Col md={10}>
                            <div className='map-wrapper mt-4'>
                                <iframe
                                    src={contactData.embed}
                                    width="100%"
                                    height="400"
                                    allowFullScreen
                                    loading="lazy"
                                    referrerPolicy="no-referrer-when-downgrade"
                                    title="Ubit Harita"
                                ></iframe>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </div>
    );
}

export default Contact;
